import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateResellerVerification } from "./updateResellerVerification.request";

const useUpdateResellerVerification = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateResellerVerification,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateResellerVerification;
